import React, { useState, useEffect, useRef } from 'react';
import Axios from 'axios';
import "../ShippingData.css";
import "./Add_Part_Dataset.css";
import { Host } from '../App';

function Add_Internal_Part_Dataset() {
  const token = window.localStorage.getItem("acessToken");
  let rawName = window.localStorage.getItem("Name") || "";
  const userName = rawName.replace(/[{}"']/g, "").trim();

  const [editable, setEditable] = useState(false);
  const [updateable, setUpdateable] = useState(false);
  const [editAllMode, setEditAllMode] = useState(false);
  const [del, setDel] = useState(0);
  const [partDataset, setPartDataset] = useState([]);
  const [auditLogs, setAuditLogs] = useState([]);
  const [showAudit, setShowAudit] = useState(false);

  const originalDataRef = useRef([]);

  const [data, setData] = useState([
    {
      Part_No: "",
      Part_internalNo: "",
      Part_Description: "",
      Customer: "",
      Category: "",
      Type: "",
      Connection_Type: ""
    }
  ]);

  const [filters, setFilters] = useState({
    PartNo: "",
    PartDesc: "",
    Customers: "",
    Category: "",
    InternalPart: "",
    Type: "",
  });

  // Fetch main data
  useEffect(() => {
    Axios.get(` https://${Host}/api/get/Internal/partdataset`, {
      params: { ...filters, token }
    }).then((res) => {
      setPartDataset(res.data);
    });
  }, [filters, del, token]);

  const fetchAuditLogs = () => {
    Axios.get(` https://${Host}/api/get/Internal/auditLog`, { params: { token } })
      .then((res) => {
        setAuditLogs(res.data);
        setShowAudit(true);
      })
      .catch(err => console.error("Error fetching audit logs", err));
  };

  // Auto-fill for add form
  const submitValue = (e, index) => {
    const selected = partDataset.find(x => x.PartNo === e.target.value);
    if (selected) {
      const newData = [...data];
      newData[index].Customer = selected.Customer;
      newData[index].Part_Description = selected.Part_description;
      newData[index].Category = selected.CATEGORY;
      newData[index].Type = selected.Type;
      setData(newData);
    }
  };

  const addRow = () => {
    setData([...data, { Part_No: "", Part_internalNo: "", Part_Description: "", Customer: "", Category: "", Type: "", Connection_Type: "" }]);
  };

  const removeRow = (index) => {
    setData(data.filter((_, i) => i !== index));
  };

  const submitpart = () => {
    const filteredData = data.filter(row => row.Part_No && row.Part_internalNo);
    if (filteredData.length === 0) {
      alert("Please fill at least Part No and Internal Part No");
      return;
    }
    Axios.post(` https://${Host}/api/add/InternalpartDataset`, { Data: filteredData, token })
      .then((response) => {
        if (response.status === 200) {
          alert(response.data.message);
          setData([{ Part_No: "", Part_internalNo: "", Part_Description: "", Customer: "", Category: "", Type: "", Connection_Type: "" }]);
          setEditable(false);
          setDel(del + 1);
        }
      });
  };

  // Edit internal only
  const handleUpdateChange = (index, value) => {
    const updated = [...partDataset];
    updated[index].Part_internalNo = value;
    setPartDataset(updated);
  };

  const updateInternalOnly = () => {
    Axios.post(` https://${Host}/api/internalpartDataset/Update`, {
      changedData: JSON.stringify(partDataset),
      token,
      userName
    }).then((response) => {
      if (response.status === 200) {
        alert(response.data.message);
        setUpdateable(false);
        setDel(del + 1);
      }
    });
  };

  // Full edit mode
  const handleFullEditChange = (index, field, value) => {
    const updated = [...partDataset];
    updated[index][field] = value;
    setPartDataset(updated);
  };

  // Compare using the actual column names from the dataset
  const isRowChanged = (original, current) => {
    const fieldsToCompare = [
      'Part_internalNo', 'Part_description', 'Customer',
      'CATEGORY', 'Type', 'Part_Type'
    ];
    for (let field of fieldsToCompare) {
      if ((original[field] || '') !== (current[field] || '')) {
        return true;
      }
    }
    return false;
  };

  const saveFullEdits = () => {
    const changedRows = [];
    for (let i = 0; i < partDataset.length; i++) {
      const originalRow = originalDataRef.current[i];
      const currentRow = partDataset[i];
      if (originalRow && isRowChanged(originalRow, currentRow)) {
        // Map frontend column names to backend expected names
        const mappedRow = {
          Sr_No: currentRow.Sr_No,
          Part_No: currentRow.PartNo,               // backend expects Part_No
          Part_internalNo: currentRow.Part_internalNo,
          Type: currentRow.Type,
          Part_Type: currentRow.Part_Type,
          Part_Description: currentRow.Part_description, // backend expects Part_Description
          Customer: currentRow.Customer,
          CATEGORY: currentRow.CATEGORY             // uppercase
        };
        changedRows.push(mappedRow);
      }
    }

    if (changedRows.length === 0) {
      alert("No changes detected.");
      setEditAllMode(false);
      return;
    }

    Axios.post(` https://${Host}/api/internalpartDataset/UpdateAll`, {
      updatedData: changedRows,
      token,
      userName
    }).then((response) => {
      if (response.status === 200) {
        alert(response.data.message);
        setEditAllMode(false);
        setDel(del + 1);
      } else {
        alert(response.data.message || "Update failed");
      }
    }).catch(err => {
      console.error(err);
      alert("Error updating data");
    });
  };

  const cancelFullEdits = () => {
    setEditAllMode(false);
    setDel(del + 1);
  };

  const enableEditAll = () => {
    originalDataRef.current = JSON.parse(JSON.stringify(partDataset));
    setUpdateable(false);
    setEditAllMode(true);
  };

  const enableUpdateable = () => {
    setEditAllMode(false);
    setUpdateable(true);
  };

  // Allow both Kenil Shah and vikas Harkyal (or change as needed)
  const isAuthorizedForFullEdit = (userName.toLowerCase() === "kenil shah" || userName.toLowerCase() === "vikas harkyal");

  return (
    <div className="MainPage_data">
      <div className="Container">
        <br />
        <h2 style={{ padding: 10 }}>Internal Part Dataset</h2>
        <br />

        {/* ADD SECTION */}
        {editable && (
          <div className="add_section">
            <center>
              {data.map((line, index) => (
                <div key={index} className="row mb-3" style={{ borderBottom: "1px solid #ddd", paddingBottom: 10 }}>
                  <div className="col">
                    <label>Part No</label>
                    <input type="text" className="form-control" list="PartNoList" value={line.Part_No}
                      onChange={(e) => { const newData = [...data]; newData[index].Part_No = e.target.value; setData(newData); }}
                      onBlur={(e) => submitValue(e, index)} />
                  </div>
                  <div className="col">
                    <label>Internal Part No</label>
                    <input type="text" className="form-control" value={line.Part_internalNo}
                      onChange={(e) => { const newData = [...data]; newData[index].Part_internalNo = e.target.value; setData(newData); }} />
                  </div>
                  <div className="col">
                    <label>Description</label>
                    <input type="text" className="form-control" value={line.Part_Description}
                      onChange={(e) => { const newData = [...data]; newData[index].Part_Description = e.target.value; setData(newData); }} />
                  </div>
                  <div className="col">
                    <label>Customer</label>
                    <input type="text" className="form-control" list="CustomerList" value={line.Customer}
                      onChange={(e) => { const newData = [...data]; newData[index].Customer = e.target.value; setData(newData); }} />
                  </div>
                  <div className="col">
                    <label>Category</label>
                    <input type="text" className="form-control" value={line.Category}
                      onChange={(e) => { const newData = [...data]; newData[index].Category = e.target.value; setData(newData); }} />
                  </div>
                  <div className="col">
                    <label>Type</label>
                    <input type="text" className="form-control" list="TypeList" value={line.Type}
                      onChange={(e) => { const newData = [...data]; newData[index].Type = e.target.value; setData(newData); }} />
                  </div>
                  <div className="col">
                    <label>Connection</label>
                    <select className="form-control" value={line.Connection_Type}
                      onChange={(e) => { const newData = [...data]; newData[index].Connection_Type = e.target.value; setData(newData); }}>
                      <option value=""></option>
                      <option value="Sub Part">With Shipped</option>
                      <option value="Main Part">With Flex</option>
                    </select>
                  </div>
                  <div className="col d-flex align-items-end">
                    <button className="btn btn-danger" onClick={() => removeRow(index)}>Remove</button>
                  </div>
                </div>
              ))}
            </center>
            <div>
              <button className="btn btn-secondary me-2" onClick={addRow}>+ Add Row</button>
              <button className="btn btn-success" onClick={submitpart}>Submit All</button>
            </div>
          </div>
        )}
        <hr />

        {/* FILTERS & BUTTONS */}
        <div className="row mt-6">
          {["PartNo", "PartDesc", "InternalPart", "Customers", "Category", "Type"].map((field) => (
            <div className="col" key={field}>
              <input type="text" className="form-control" placeholder={field}
                onChange={(e) => setFilters(prev => ({ ...prev, [field]: e.target.value }))} />
            </div>
          ))}
          <div className="col">
            <button className="btn btn-primary me-2" onClick={() => setEditable(!editable)}>Add Internal No</button>
            <button className="btn btn-success me-2" onClick={enableUpdateable}>Edit Internal No</button>
            {isAuthorizedForFullEdit && (
              <button className="btn btn-warning me-2" onClick={enableEditAll}>Edit All Fields</button>
            )}
            {editAllMode && (
              <>
                <button className="btn btn-success me-2" onClick={saveFullEdits}>Save All Changes</button>
                <button className="btn btn-secondary" onClick={cancelFullEdits}>Cancel</button>
              </>
            )}
          </div>
        </div>

        {/* DATA TABLE */}
        <div className="datatable-wide_part mt-4">
          <table className="table table-bordered table-striped">
            <thead>
              <tr><th>PART NO</th><th>INTERNAL PART NO</th><th>DESCRIPTION</th><th>CUSTOMER</th><th>CATEGORY</th><th>TYPE</th><th>CONNECTION TYPE</th></tr>
            </thead>
            <tbody>
              {partDataset.map((val, idx) => (
                <tr key={idx}>
                  <td>{val.PartNo}</td>
                  <td>
                    {(updateable || editAllMode) ? (
                      <input type="text" className="form-control" value={val.Part_internalNo || ""}
                        onChange={(e) => editAllMode ? handleFullEditChange(idx, "Part_internalNo", e.target.value) : handleUpdateChange(idx, e.target.value)} />
                    ) : val.Part_internalNo}
                  </td>
                  <td>
                    {editAllMode ? (
                      <input type="text" className="form-control" value={val.Part_description || ""}
                        onChange={(e) => handleFullEditChange(idx, "Part_description", e.target.value)} />
                    ) : val.Part_description}
                  </td>
                  <td>
                    {editAllMode ? (
                      <input type="text" className="form-control" list="CustomerList" value={val.Customer || ""}
                        onChange={(e) => handleFullEditChange(idx, "Customer", e.target.value)} />
                    ) : val.Customer}
                  </td>
                  <td>
                    {editAllMode ? (
                      <input type="text" className="form-control" value={val.CATEGORY || ""}
                        onChange={(e) => handleFullEditChange(idx, "CATEGORY", e.target.value)} />
                    ) : val.CATEGORY}
                  </td>
                  <td>
                    {editAllMode ? (
                      <input type="text" className="form-control" list="TypeList" value={val.Type || ""}
                        onChange={(e) => handleFullEditChange(idx, "Type", e.target.value)} />
                    ) : val.Type}
                  </td>
                  <td>
                    {editAllMode ? (
                      <select className="form-control" value={val.Part_Type || ""}
                        onChange={(e) => handleFullEditChange(idx, "Part_Type", e.target.value)}>
                        <option value=""></option>
                        <option value="Sub Part">With Shipped</option>
                        <option value="Main Part">With Flex</option>
                      </select>
                    ) : (val.Part_Type === "Sub Part" ? "With Shipped" : (val.Part_Type === "Main Part" ? "With Flex" : val.Part_Type))}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {updateable && (
            <div className="mt-3">
              <button className="btn btn-success" onClick={updateInternalOnly}>Save Internal No Updates</button>
            </div>
          )}
        </div>

        <br />
        <button className="btn btn-info" onClick={fetchAuditLogs}>
          {showAudit ? "Refresh Activity Log" : "Show Activity Log"}
        </button>
        <hr />

        {showAudit && (
          <div className="mt-3 audit-log-container">
            <table className="table audit-log-table">
              <thead>
                <tr>
                  <th>Timestamp</th><th>Changed By</th><th>Part No</th><th>Action</th><th>Changes</th>
                </tr>
              </thead>
              <tbody>
                {auditLogs.map((log, idx) => {
                  const changes = [];
                  if (log.Old_Part_internalNo !== log.New_Part_internalNo) changes.push({ field: "Internal No", old: log.Old_Part_internalNo, new: log.New_Part_internalNo });
                  if (log.Old_Part_Description !== log.New_Part_Description) changes.push({ field: "Description", old: log.Old_Part_Description, new: log.New_Part_Description });
                  if (log.Old_Customer !== log.New_Customer) changes.push({ field: "Customer", old: log.Old_Customer, new: log.New_Customer });
                  if (log.Old_CATEGORY !== log.New_CATEGORY) changes.push({ field: "Category", old: log.Old_CATEGORY, new: log.New_CATEGORY });
                  if (log.Old_Type !== log.New_Type) changes.push({ field: "Type", old: log.Old_Type, new: log.New_Type });
                  if (log.Old_Part_Type !== log.New_Part_Type) {
                    const map = (v) => v === "Sub Part" ? "With Shipped" : (v === "Main Part" ? "With Flex" : v);
                    changes.push({ field: "Connection", old: map(log.Old_Part_Type), new: map(log.New_Part_Type) });
                  }
                  return (
                    <tr key={idx}>
                      <td>{new Date(log.Change_Timestamp).toLocaleString()}</td>
                      <td>{log.Changed_By}</td>
                      <td>{log.Part_No}</td>
                      <td>
                        <span className={`action-badge ${log.Action_Type === "UPDATE_INTERNAL_ONLY" ? "badge-internal" : log.Action_Type === "INSERT" ? "badge-insert" : "badge-full"}`}>
                          {log.Action_Type === "INSERT" ? "New Record" : (log.Action_Type === "UPDATE_INTERNAL_ONLY" ? "Internal No Only" : "Full Update")}
                        </span>
                      </td>
                      <td>
                        {changes.length === 0 ? <span className="no-change">No visible changes</span> :
                          changes.map((c, i) => (
                            <div key={i} className="change-item">
                              <strong>{c.field}:</strong> <span className="old-value">{c.old || "—"}</span> → <span className="new-value">{c.new || "—"}</span>
                            </div>
                          ))}
                      </td>
                    </tr>
                  );
                })}
                {auditLogs.length === 0 && <tr><td colSpan="5" className="text-center">No audit records found</td></tr>}</tbody>
            </table>
          </div>
        )}

        {/* Datalists */}
        <datalist id="PartNoList">{partDataset.map((x, i) => <option key={i} value={x.PartNo} />)}</datalist>
        <datalist id="CustomerList">{[...new Set(partDataset.map(x => x.Customer))].map((c, i) => <option key={i} value={c} />)}</datalist>
        <datalist id="TypeList">{[...new Set(partDataset.map(x => x.Type))].map((t, i) => <option key={i} value={t} />)}</datalist>
      </div>
    </div>
  );
}

export default Add_Internal_Part_Dataset;